module.exports = __webpack_public_path__ + "118e72f1aea9e7e5e5918676a87e9c8f.png";